import { PRISTINE_SEED } from './fixtures';
import { registerOnEnable } from '../services/demoMode';

const deepClone = (v) => (typeof structuredClone === 'function'
  ? structuredClone(v)
  : JSON.parse(JSON.stringify(v)));

let store = deepClone(PRISTINE_SEED);

export function getDemoStore() { return store; }
export function resetDemoStore() { store = deepClone(PRISTINE_SEED); }

// Every time demo mode is enabled (incl. on a fresh page load), re-seed.
registerOnEnable(resetDemoStore);
